import { reportsApi } from 'Api/axios/reports-api';
import { useEffect, useState } from 'react';
import type { EmployeeReportI, EmployeeReportFilterI } from 'types';

interface Props {
  init?: boolean;
}

const useEmployeesReportApi = ({ init = false }: Props) => {
  const [data, setData] = useState<EmployeeReportI[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchEmployeesReport = async (filters: EmployeeReportFilterI = {}) => {
    setLoading(true);
    const response = await reportsApi.readEmployees(filters);
    setLoading(false);
    if (response.data) {
      setData(response.data ?? []);
    } else {
      setError(response.error ?? 'No hay datos disponibles');
    }
  };

  useEffect(() => {
    if (init) {
      fetchEmployeesReport();
    }
  }, [init]);

  return { data, loading, error, fetchEmployeesReport };
};

export default useEmployeesReportApi;
